import Vue from 'vue'
import Router from 'vue-router'
import CallProfessional from '@/components/professional/Call'
import Email from '@/components/professional/Email'
import SipCall from '@/components/professional/SipCall'
import Profile from '@/components/professional/Profile'
import CallUser from '@/components/user/Call'
import Create from '@/components/professional/Create'
import ListProfessionals from '@/components/admin/ListProfessionals'
import CreateProfessional from '@/components/admin/CreateProfessional'
import Stats from '@/components/admin/Stats'
import Join from '@/components/user/Join'
import Login from '@/components/professional/Login'
import Recovery from '@/components/professional/Recovery'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        { path: '/', redirect: '/login' },
        { path: '/create', name: 'Create', component: Create },
        { path: '/login', name: 'Login', component: Login },
        { path: '/professional/call', name: 'CallProfessional', component: CallProfessional },
        { path: '/professional/call/:appointment', name: 'CallProfessional', component: CallProfessional },
        { path: '/professional/email/:session', name: 'Email', component: Email },
        { path: '/professional/phonecall/:session', name: 'SipCall', component: SipCall },
        { path: '/professional/profile', name: 'Profile', component: Profile },
        { path: '/recovery', name: 'Recovery', component: Recovery },
        { path: '/admin/professionals', name: 'ListProfessionals', component: ListProfessionals },
        { path: '/admin/stats', name: 'Stats', component: Stats },
        { path: '/admin/create', name: 'CreateProfessional', component: CreateProfessional },
        { path: '/call', name: 'CallUser', component: CallUser },
        { path: '/join/:session', name: 'Join', component: Join },
        { path: '/join/:session/:accept', name: 'Join', component: Join },
        { path: '*', redirect: '/' },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js